import { EventType } from "@/types";

export interface EventTypeConfig {
  hex: string;
  tailwind: string;
  label: string; // i18n key
}

/**
 * Centralized event type color configuration
 * Ensures consistency between calendar display and legend
 */
export const EVENT_TYPE_COLORS: Record<EventType, EventTypeConfig> = {
  race: {
    hex: "#ef4444",
    tailwind: "bg-red-500",
    label: "events:types.race",
  },
  practice: {
    hex: "#10b981",
    tailwind: "bg-emerald-500",
    label: "events:types.practice",
  },
  trackday: {
    hex: "#8b5cf6",
    tailwind: "bg-purple-500",
    label: "events:types.trackday",
  },
  time_attack: {
    hex: "#f59e0b",
    tailwind: "bg-amber-500",
    label: "events:types.time_attack",
  },
  target_time_attack: {
    hex: "#f59e0b",
    tailwind: "bg-amber-500",
    label: "events:types.target_time_attack",
  },
  drift: {
    hex: "#ec4899",
    tailwind: "bg-pink-500",
    label: "events:types.drift",
  },
  endurance: {
    hex: "#06b6d4",
    tailwind: "bg-cyan-500",
    label: "events:types.endurance",
  },
  gymkhana: {
    hex: "#14b8a6",
    tailwind: "bg-teal-500",
    label: "events:types.gymkhana",
  },
  autocross: {
    hex: "#14b8a6",
    tailwind: "bg-teal-500",
    label: "events:types.autocross",
  },
  simracing: {
    hex: "#6366f1",
    tailwind: "bg-indigo-500",
    label: "events:types.simracing",
  },
  other: {
    hex: "#6b7280",
    tailwind: "bg-secondary-500",
    label: "events:types.other",
  },
};

/**
 * Get event type color configuration
 * @param eventType - The event type
 * @returns Color configuration or default gray
 */
export function getEventTypeColor(eventType: EventType): EventTypeConfig {
  return EVENT_TYPE_COLORS[eventType] || EVENT_TYPE_COLORS.other;
}

/**
 * Event types to show in calendar legend (most commonly used)
 */
export const CALENDAR_LEGEND_TYPES: EventType[] = [
  "race",
  "practice",
  "trackday",
  "time_attack",
  "drift",
  "gymkhana",
  "simracing",
  "endurance",
];
